import { render, staticRenderFns } from "./AulasPraticas.vue?vue&type=template&id=9b1e923c&scoped=true"
import script from "./AulasPraticas.vue?vue&type=script&lang=js"
export * from "./AulasPraticas.vue?vue&type=script&lang=js"
import style0 from "./AulasPraticas.vue?vue&type=style&index=0&id=9b1e923c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1e923c",
  null
  
)

export default component.exports